import React, { useState, useId } from 'react';

// A home-page panel (noticeboard, birthdays, competitions). When collapsible,
// the header becomes a full-width button showing the title and a badge (e.g.
// "2 unread"), and the body only renders once opened.
export default function DashboardPanel({
  className,
  headerClassName,
  title,
  badge = null,
  collapsible = false,
  defaultOpen = true,
  children,
}) {
  const [open, setOpen] = useState(collapsible ? defaultOpen : true);
  const bodyId = useId();

  const header = (
    <>
      {title}
      <span className="dashboard-panel__right">
        {badge}
        {collapsible && <span className="dashboard-panel__chevron" aria-hidden="true">▾</span>}
      </span>
    </>
  );

  return (
    <div className={`${className}${open ? '' : ' dashboard-panel--collapsed'}`}>
      {collapsible ? (
        <button
          type="button"
          className={`${headerClassName} dashboard-panel__toggle`}
          aria-expanded={open}
          aria-controls={bodyId}
          onClick={() => setOpen(o => !o)}
        >
          {header}
        </button>
      ) : (
        <div className={headerClassName}>{header}</div>
      )}
      {open && <div id={bodyId}>{children}</div>}
    </div>
  );
}
